/** iOS-style on/off switch. Always pair it with a visible label. */
export function Switch({
  checked,
  onChange,
  label,
  disabled = false,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Accessible name when the visible label is not a <label> for this control. */
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`flex h-[31px] w-[51px] shrink-0 items-center rounded-full p-[2px] transition-colors duration-[180ms] ease-out focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-elev disabled:cursor-not-allowed disabled:opacity-50 ${checked ? 'bg-accent' : 'bg-strong'}`}
    >
      <span
        className={`h-[27px] w-[27px] rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.2)] transition-transform duration-[180ms] ease-out ${checked ? 'translate-x-5' : ''}`}
      />
    </button>
  );
}
